module.exports = __webpack_public_path__ + "img/border2.22282218.png";